import graphic_footer from '@client/shared/styles/assets/shapes/graphic-footer.png';
import graphic_footer_x2 from '@client/shared/styles/assets/shapes/graphic-footer@2x.png';
import graphic_footer_mobile from '@client/shared/styles/assets/shapes/graphic-footer_mobile.png';
import graphic_footer_mobile_x2 from '@client/shared/styles/assets/shapes/graphic-footer_mobile@2x.png';
import graphic_header from '@client/shared/styles/assets/shapes/graphic-header.png';
import graphic_header_2 from '@client/shared/styles/assets/shapes/graphic-header-2.png';
import graphic_header_3 from '@client/shared/styles/assets/shapes/graphic-header-3.png';
import graphic_header_x2 from '@client/shared/styles/assets/shapes/graphic-header@2x.png';
import graphic_header_2_x2 from '@client/shared/styles/assets/shapes/graphic-header-2@2x.png';
import graphic_header_3_x2 from '@client/shared/styles/assets/shapes/graphic-header-3@2x.png';
import graphic_header_mobile from '@client/shared/styles/assets/shapes/graphic-header-mobile.png';
import graphic_header_mobile_2 from '@client/shared/styles/assets/shapes/graphic-header-mobile-2.png';
import graphic_header_mobile_x2 from '@client/shared/styles/assets/shapes/graphic-header-mobile@2x.png';
import graphic_header_mobile_2_x2 from '@client/shared/styles/assets/shapes/graphic-header-mobile-2@2x.png';
import graphic_letters from '@client/shared/styles/assets/shapes/graphic-letters.png';
import graphic_letters_x2 from '@client/shared/styles/assets/shapes/graphic-letters@2x.png';
import graphic_panel from '@client/shared/styles/assets/shapes/graphic-panel-1.png';
import graphic_panel_mobile from '@client/shared/styles/assets/shapes/graphic-panel-mobile.png';
import graphic_panel_2x from '@client/shared/styles/assets/shapes/graphic-panel-1@2x.png';
import graphic_mall_2 from '@client/shared/styles/assets/shapes/graphic-mall-2.png';
import graphic_mall_2_2x from '@client/shared/styles/assets/shapes/graphic-mall-2@2x.png';
import graphic_mall_3 from '@client/shared/styles/assets/shapes/graphic-mall-3.png';
import graphic_mall_3_2x from '@client/shared/styles/assets/shapes/graphic-mall-3@2x.png';
import graphic_about from '@client/shared/styles/assets/shapes/graphic-about.png';
import graphic_about_mobile from '@client/shared/styles/assets/shapes/graphic-header-mobile-3.png';

export default {
  graphic_footer,
  graphic_footer_x2,
  graphic_footer_mobile,
  graphic_footer_mobile_x2,
  graphic_header,
  graphic_header_x2,
  graphic_header_2,
  graphic_header_2_x2,
  graphic_header_3,
  graphic_header_3_x2,
  graphic_header_mobile,
  graphic_header_mobile_x2,
  graphic_header_mobile_2,
  graphic_header_mobile_2_x2,
  graphic_letters,
  graphic_letters_x2,
  graphic_panel,
  graphic_panel_2x,
  graphic_panel_mobile,
  graphic_mall_3,
  graphic_mall_3_2x,
  graphic_mall_2,
  graphic_mall_2_2x,
  graphic_about,
  graphic_about_mobile,
};
